import { Box, Center, Text } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import FancyBearImage from "components/FancyBearImage";
import SelectionIndicator from "components/SelectionIndicator";
import { ImageSize } from "types";

type FancyBearCardProps = {
  tokenId: number;
  imageSize?: ImageSize;
  isSelected?: boolean;
  isBusy?: boolean;
  isDisabled?: boolean;
  badgeText?: string;
  onClick?: (tokenId: number) => void;
};

const FancyBearCard: React.FC<FancyBearCardProps> = ({
  tokenId,
  imageSize,
  isDisabled = false,
  isSelected = false,
  isBusy = false,
  children,
  badgeText,
  onClick,
}) => (
  <Box
    bg="bright.500"
    p="2"
    w="full"
    outline="2px solid"
    userSelect="none"
    outlineColor={isSelected ? "dark.base" : "transparent"}
    cursor={isDisabled ? "not-allowed" : onClick ? "pointer" : "default"}
    transition="all 0.15s"
    tabIndex={0}
    onClick={() => {
      if (!isDisabled && onClick) {
        onClick(tokenId);
      }
    }}
  >
    <Box position="relative">
      <FancyBearImage
        size={imageSize}
        tokenId={tokenId}
        isDisabled={isDisabled || isBusy}
      />

      <SelectionIndicator
        position="absolute"
        top="-2"
        left="-2"
        isSelected={isSelected}
      />

      <Center
        position="absolute"
        top="-2"
        right="-2"
        bg="bright.500"
        w="10"
        h="10"
        zIndex="dropdown"
        opacity={isBusy ? "1" : "0"}
        transition="opacity 0.15s"
      >
        {isBusy && <BoldSpinner size="sm" thickness="3px" />}
      </Center>

      {badgeText && (
        <Box
          position="absolute"
          top="50%"
          left="50%"
          bg="dark.500"
          px="4"
          py="2"
          transform="translate(-50%, -50%)"
        >
          <Text fontWeight="600" fontSize="sm" color="bright.400">
            {badgeText}
          </Text>
        </Box>
      )}
    </Box>

    <Box px="2" pt="3" pb="1">
      {children}
    </Box>
  </Box>
);

export default FancyBearCard;
